export const JPUSH_ID_KEY = "JPUSH_ID";

export const AUDIT_STATUS_TEXT: any = {
  0: '暂未开通',
  1: '审核中',
  2: '审核通过',
  3: '审核未通过',
};